const featureExchangeApi = ({ exchange, exchangeLimits, exchangeQuotes, exchangeAssets, exchangeAssetAvailability, }) => ({
    exchange: {
        getBestQuote: exchangeQuotes.getBestQuote,
        getMaxQuote: exchangeQuotes.getMaxQuote,
        getLimits: exchangeLimits.getLimits,
        ackExchange: exchange.ackExchange,
        exchange: exchange.exchange,
        addAndEnableToken: exchangeAssets.addAndEnableToken,
        getSupportedFromAssetIds: exchangeAssetAvailability.getSupportedFromAssetIds,
        getSupportedToAssetIds: exchangeAssetAvailability.getSupportedToAssetIds,
        prefetchPairs: exchangeAssetAvailability.startAssetAvailabilityMonitor,
        searchAssets: exchangeAssets.searchAssets,
        isAssetExchangeable: exchangeAssetAvailability.isAssetExchangeable,
        isExactOutSupported: exchangeAssetAvailability.isExactOutSupported,
    },
});
const exchangeDefinition = {
    id: 'exchangeApi',
    type: 'api',
    factory: featureExchangeApi,
    dependencies: [
        'exchange',
        'exchangeLimits',
        'exchangeQuotes',
        'exchangeAssetAvailability',
        'exchangeAssets',
    ],
    public: true,
};
export default exchangeDefinition;
